import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { useT } from "@/lib/content";

const DISCLAIMER_FALLBACK = `Teuralink is a private commemorative registry offering symbolic Moon and Mars-themed gift experiences. All certificates, registry entries, maps, and related products are commemorative novelty items intended for gifting, collecting, entertainment, and personal enjoyment. They do not confer legal ownership, property rights, government-recognized title, or any legally enforceable interest in land on the Moon, Mars, or any other celestial body. All registry records are maintained exclusively within the Private Teuralink Commemorative Registry.`;

export default function Footer() {
  const tagline = useT("footer.tagline",
    "Commemorative land registration for the Moon and Mars. A luxury keepsake for dreamers, explorers, and future citizens of the cosmos.");
  const disclaimer = useT("footer.disclaimer", DISCLAIMER_FALLBACK);
  const email = useT("contact.email", "support@teuralink.com");
  return (
    <footer className="relative z-10 mt-32 border-t border-white/10 bg-black/60 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="font-display text-3xl font-bold tracking-tight">Teuralink</div>
            <p className="mt-3 text-sm text-white/60 max-w-md leading-relaxed">
              {tagline}
            </p>
            <a
              href={`mailto:${email}`}
              className="mt-5 inline-flex items-center gap-2 text-sm text-white/70 hover:text-white"
              data-testid="footer-email"
            >
              <Mail className="w-4 h-4 text-gold" /> {email}
            </a>
          </div>

          <div>
            <div className="overline mb-4">Explore</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/explore/moon" className="hover:text-white">The Moon</Link></li>
              <li><Link to="/explore/mars" className="hover:text-white">Mars</Link></li>
              <li><Link to="/verify" className="hover:text-white">Verify Registration</Link></li>
              <li><Link to="/track" className="hover:text-white">Track Shipment</Link></li>
            </ul>
          </div>

          <div>
            <div className="overline mb-4">Company</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact">Contact Us</Link></li>
              <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
              <li><Link to="/refund" className="hover:text-white" data-testid="footer-refund">Refund &amp; Cancellation</Link></li>
              <li><Link to="/legal" className="hover:text-white" data-testid="footer-legal">Disclaimer</Link></li>
              <li><Link to="/admin/login" className="hover:text-white">Admin</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10">
          <p className="text-[11.5px] leading-relaxed text-white/55" data-testid="footer-disclaimer">
            {disclaimer}
          </p>
          <div className="mt-4 flex flex-col md:flex-row md:items-center justify-between gap-2 text-xs text-white/45">
            <div>© {new Date().getFullYear()} Teuralink. All rights reserved.</div>
            <div>Premium Commemorative Moon &amp; Mars Gift Registry · Made in India</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
